// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import MagicLinksController from "./magic_links_controller.js";
application.register("magic-links", MagicLinksController);
import CustomCategoryController from "./custom_category_controller.js";
application.register("custom-category", CustomCategoryController);
import FormActionsController from "./form_actions_controller.js";
application.register("form-actions", FormActionsController);
import DonorNudgeController from "./donor_nudge_controller.js";
application.register("donor-nudge", DonorNudgeController);

import VideoGridInfiniteScrollController from "./video_grid_infinite_scroll_controller.js";
application.register(
  "video-grid-infinite-scroll",
  VideoGridInfiniteScrollController
);
import VideoTrimController from "./video_trim_controller.js";
application.register("video-trim", VideoTrimController);
